module.exports = __webpack_public_path__ + "img/combination_text.091ac40.jpg";